import React from 'react';

import 'src/components/EmptyListing.scss';


const EmptyListing = () => {
  const headline = 'Coś poszło nie tak';
  const subline = 'Spróbuj ponownie za jakiś czas';

  return (
    <div styleName="empty-listing">
      <div styleName="empty-listing__icon">
        <span className="mdi mdi-alert" />
      </div>

      <h3 styleName="empty-listing__header">{ headline }</h3>
      { subline }
    </div>
  );
};


export default EmptyListing;
